<!--表单页面拷贝开始-->
<template>
  <div>
    <form-components @submitForm="submitForm">
      <template v-slot:content>
        <el-form-item label="规则代码">
          <el-col :span="8">
            <el-input v-model="sysRule.code"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="规则名称">
          <el-col :span="8">
            <el-input v-model="sysRule.name"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="备注信息">
          <el-col :span="8">
            <el-input v-model="sysRule.remark"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="规则内容">
          <el-col :span="18">
            <!-- <el-input v-model="sysRule.content"></el-input> -->
            <codemirror
              ref="mycode"
              :options="cmOptions"
              v-model="sysRule.content"
              class="code"
            ></codemirror>
          </el-col>
        </el-form-item>
      </template>
    </form-components>
  </div>
</template>

<script>
import FormComponents from "@/components/form/FormComponents";
import SysRuleApi from "@/api/SysRuleApi";
import { navTo, queryParam } from "@/utils/NavigatorUtils";
import "codemirror/theme/ambiance.css"; 
export default {
  name: "SaveSysRulePage",
  props: {
    msg: String,
  },
  components: {
    FormComponents,
  },
  data() {
    return {
      sysRule: {
        id: "",
        name: "",
        code: "",
        content: "",
        remark: "",
      },
      cmOptions: {
        mode: "text/x-java",
        theme: "ambiance",
        styleActiveLine: true, // 高亮光标所在行
        smartIndent: true, // 开启自动缩进
        tabSize: 2,
        readOnly: false,
        lineNumbers: true, // 行号
      },
    };
  },
  created() {
    this.sysRule = this.$route.params;
  },
  methods: {
    submitForm() {
      this.sysRule.id > 0 ? this.updateSysRuleById() : this.addSysRule();
    },
    addSysRule() {
      SysRuleApi.saveSysRule(this.sysRule).then((resp) => {
        if (resp.state == "OK") {
          this.sysRule = {};
          this.$successMsg(resp.msg);
        } else {
          this.$errorMsg(resp.msg);
        }
      });
    },
    updateSysRuleById() {
      SysRuleApi.updateSysRule(this.sysRule).then((resp) => {
        if (resp.state == "OK") {
          this.user = {};
          this.$successMsg(resp.msg);
          navTo(this, "/sysRuleList");
        } else {
          this.$errorMsg(resp.msg);
        }
      });
    }
  },
};
</script>


<!--表单页面拷贝结束-->